import _extend from 'lodash/extend';

function Ctrl($scope, $uibModalInstance, input) {
  $scope.cancel = function() {
    $uibModalInstance.dismiss(false);
  };

  $scope.config = _extend(input, {
    success: function(resp) {
      $uibModalInstance.close(resp);
    },
    error: function(resp) {
      $scope.cancel(resp);
    },
    compactLayout: true
  });
}

Ctrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'input'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/services/modal/login/loginModalCtrl.js